import { TrashIcon as BetaTrashIcon } from '@mm/icons';
import classNames from 'classnames';
import React from 'react';
import { Button, ButtonProps } from '../Button/Button';
import styles from './DeleteButton.module.css';

type Props = Omit<ButtonProps, 'leftIcon'> & {
  className?: string;
};

export const DeleteButton = ({ className, ...rest }: Props) => {
  const css = {
    ...rest.css,
    container: classNames(className, styles.deleteButton, rest.css?.container),
  };
  return <Button {...rest} css={css} leftIcon={<BetaTrashIcon />} />;
};
